import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Typography } from '@mui/material';
import { Formik } from 'formik';
import { AppPrimaryButton } from 'shared/components/AppComponents';

import { ManagePacketService } from 'services/ManagePacketService';
import { Utils } from 'shared/helpers';

const DeletationModal: React.FC<Props> = React.forwardRef(
    (
        {
            callbackClosingModal,
            callbackOpenModal,
            callbackDeletationModal,
            packetId,
        },
        ref
    ): React.ReactElement => {
        const [open, setOpen] = React.useState(false);
        const [confirmation, setConfirmation] = React.useState<boolean>(false);

        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);
        const handleDeletation = React.useCallback((): void => {
            setConfirmation(true);
            ManagePacketService.deletePacket(packetId)
                .then((response) => {
                    Utils.handleSuccessResponse(response);
                    setConfirmation(false);
                    setOpen(false);
                    if (typeof callbackDeletationModal === 'function')
                        callbackDeletationModal();
                })
                .catch((response) => {
                    setConfirmation(false);
                    Utils.handleErrorResponse(response);
                });
        }, [callbackDeletationModal, packetId]);
        const handleClose = React.useCallback(() => {
            setOpen(false);
            if (typeof callbackClosingModal === 'function')
                callbackClosingModal();
        }, []);
        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
                // setReason: (message: string) => {
                //     setReason(message);
                // },
            }),
            [handleOpen, handleClose]
        );
        return (
            <Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box className="container-escalated-modal">
                        <Typography
                            variant="h6"
                            id="parent-modal-title"
                            padding={5}
                        >
                            Please note this is a permanent deletion, all files
                            associated with this Loan number will be deleted.
                        </Typography>

                        <Box className="escalated-solicitor-action">
                            <Formik
                                initialValues={{
                                    smallInput: 'Insert Here',
                                }}
                                enableReinitialize
                                onSubmit={() => {
                                    // console.log('');
                                }}
                            >
                                <Box className="containerButton">
                                    <AppPrimaryButton
                                        title="Cancel"
                                        className="btn-small back-button"
                                        onClick={() => setOpen(false)}
                                    />
                                    <AppPrimaryButton
                                        title="Confirm"
                                        className="btn-small"
                                        onClick={handleDeletation}
                                        disabled={confirmation}
                                    />
                                </Box>
                            </Formik>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default DeletationModal;
